<template>
    <div class="withdraw-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <span class="header-line"></span>
            <span class="header-title">余额提现</span>
        </div>

        <!-- 提现申请区域 -->
        <div class="withdraw-application">
            <div class="withdraw-item">
                <div class="item-label">提现金额</div>
                <div class="item-content">
                    <div class="amount-input-wrapper">
                        <span class="currency-symbol">¥</span>
                        <el-input v-model="withdrawAmount" :placeholder="`${walletDetail.user_money}可提现`"
                            style="width: 200px;"></el-input>
                        <el-button type="text" class="withdraw-all-btn" @click="withdrawAll">全部</el-button>
                    </div>
                </div>
            </div>

            <div class="withdraw-item">
                <div class="item-label">提现账号</div>
                <div class="item-content">
                    <el-input v-model="bankAccount" placeholder="请输入提现的银行卡号" style="width: 300px;"></el-input>
                </div>
            </div>

            <div class="withdraw-action">
                <el-button type="primary" class="apply-withdraw-btn" @click="applyWithdraw">申请提现</el-button>
            </div>
        </div>

        <!-- 提现明细区域 -->
        <div class="withdraw-detail">
            <div class="detail-header">
                <span class="detail-title">提现明细</span>
                <div class="date-picker-wrapper">
                    <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"
                        @change="getWithdrawDetail" style="width: 250px;" />
                </div>
            </div>

            <!-- 记录表格 -->
            <div class="record-table">
                <table>
                    <thead>
                        <tr>
                            <th>明细</th>
                            <th>提现金额</th>
                            <th>提现状态</th>
                            <th>订单号</th>
                            <th>时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="record in withdrawRecords" :key="record.id">
                            <td>{{ record.remark }}</td>
                            <td class="amount" :style="record.money_type == 1 ? 'color:green' : 'color:red'">
                                <span v-if="record.money_type == 1">+</span>{{ record.change_money }}
                            </td>
                            <td v-if="record.check_status == 1" style="color: #FF9735;">审核中</td>
                            <td v-else-if="record.check_status == 2" style="color: #333333;">已到账</td>
                            <td v-else style="color: #F02325;">审核驳回</td>
                            <td>{{ record.order_sn }}</td>
                            <td>{{ record.create_time }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <!-- 分页控件 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                </el-pagination>
            </div>
        </div>

        <!-- 提现成功弹框 -->
        <el-dialog title="提交成功" :visible.sync="successDialogVisible" width="600px" :close-on-click-modal="false"
            :close-on-press-escape="false">
            <div class="success-dialog-content">
                <div class="success-icon">
                    <!-- <el-icon name="circle-check" class="check-icon"></el-icon> -->
                    <img src="@/assets/images/71.png" class="check-icon" alt="">
                </div>
                <div class="success-title">提交申请成功</div>
                <div class="success-info">
                    <p>提现金额：{{ withdrawAmount }}</p>
                    <p>提现账号：{{ bankAccount }}元</p>
                </div>
                <div class="success-actions">
                    <el-button class="return-btn" @click="closeSuccessDialog">返回</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: 'Withdraw',
    data() {
        return {
            // 钱包详情
            walletDetail: { user_money: 0 },
            // 日期范围
            dateRange: [],
            // 提现记录数据
            withdrawRecords: [],
            // 提现金额
            withdrawAmount: '',
            // 银行卡号
            bankAccount: '',
            // 当前激活的标签页
            activeTab: '0',

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,

            // 提现成功弹框
            successDialogVisible: false,
            // 提现成功信息
            successInfo: {
                account: '',
                amount: ''
            }

        }
    },
    mounted() {
        this.getWalletDetail()
        this.getWithdrawDetail()
    },
    methods: {
        // 全部提现
        withdrawAll() {
            this.withdrawAmount = this.walletDetail.user_money || 0
        },

        // 申请提现
        applyWithdraw() {
            // 必填校验
            if (!this.withdrawAmount || parseFloat(this.withdrawAmount) <= 0) {
                this.$message({
                    message: '请输入有效的提现金额',
                    type: 'error'
                })
                return
            }

            if (!this.bankAccount || this.bankAccount.trim() === '') {
                this.$message({
                    message: '请输入提现账号',
                    type: 'error'
                })
                return
            }

            // 这里可以添加提现逻辑
            console.log(`提现金额：${this.withdrawAmount}，银行卡号：${this.bankAccount}`)
            // 实际项目中可以调用提现API
            this.$api.applyWithdrawal({
                cash_fee: this.withdrawAmount,
                account: this.bankAccount,
            }).then(res => {
                this.successDialogVisible = true
                this.getWithdrawDetail()
            }).catch(err => {
                console.error(err);
                this.$message({
                    message: err.message || '提现申请失败',
                    type: 'error'
                })
            })
        },

        // 关闭成功弹框
        closeSuccessDialog() {
            this.successDialogVisible = false
            // 刷新提现明细
            this.getWithdrawDetail()
            // 清空表单
            this.withdrawAmount = ''
            this.bankAccount = ''
        },

        // 获取钱包详情
        getWalletDetail() {
            this.$api.getWalletDetail().then(res => {
                this.walletDetail = res || {};
            })
        },

        // 获取提现明细
        getWithdrawDetail() {
            let data = {
                start_time: this.dateRange ? this.dateRange[0] : '',
                end_time: this.dateRange ? this.dateRange[1] : '',
                page: this.currentPage,
                list_rows: this.pageSize,
            }
            // 模拟API请求
            this.$api.getWithdrawDetail(data).then(res => {
                this.withdrawRecords = res.data || [];
                this.totalOrders = res.total || 0;
            })
        },


        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getWithdrawDetail();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getWithdrawDetail();
        },
    }
}
</script>

<style scoped>
.withdraw-container {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 8px;
}

/* 页面标题 */
.page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.header-line {
    display: inline-block;
    width: 4px;
    height: 20px;
    background-color: #286CED;
    margin-right: 10px;
    border-radius: 2px;
}

.header-title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
}

/* 提现申请区域 */
.withdraw-application {
    padding: 20px 0;
    margin-bottom: 30px;
}

.withdraw-item {
    margin-bottom: 25px;
    display: flex;
    align-items: center;
}

.item-label {
    width: 100px;
    font-size: 14px;
    color: #333333;
    text-align: left;
    margin-right: 20px;
}

.item-content {
    /* flex: 1; */
}

/* 金额输入 */
.amount-input-wrapper {
    display: flex;
    align-items: center;
}

.currency-symbol {
    font-size: 16px;
    color: #333333;
    margin-right: 5px;
}

.withdraw-all-btn {
    color: #286CED;
    font-size: 14px;
    margin-left: 10px;
}

/* 提现账号 */
.bank-account-input {
    width: 300px;
}

/* 申请提现按钮 */
.withdraw-action {
    display: flex;
    text-align: center;
    margin-top: 40px;
}

.apply-withdraw-btn {
    width: 150px;
    height: 40px;
    background-color: #286CED;
    border-color: #286CED;
    font-size: 16px;
    border-radius: 4px;
}

.apply-withdraw-btn:hover {
    background-color: #1e5bd8;
    border-color: #1e5bd8;
}

/* 提现明细区域 */
.withdraw-detail {
    border-top: 1px solid #f0f0f0;
    padding-top: 20px;
}

.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.detail-title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
}

.date-picker-wrapper {
    margin-top: 0;
}

/* 记录表格 */
.record-table {
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
}

th,
td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
}

th {
    background-color: #fafafa;
    color: #666666;
    font-weight: 500;
}

td {
    color: #333333;
}

.amount {
    color: #ff0000;
}

/* 状态样式 */
.status-rejected {
    color: #ff4d4f;
}

.status-completed {
    color: #67c23a;
}

.status-processing {
    color: #e6a23c;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

/* 响应式设计 */
@media (max-width: 768px) {
    .withdraw-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .item-label {
        width: auto;
        text-align: left;
        margin-bottom: 10px;
        margin-right: 0;
    }

    .detail-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    .date-picker-wrapper {
        width: 100%;
    }
}

/* 提现成功弹框样式 */
.success-dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
}

.success-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    /* background-color: #52c41a; */
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.check-icon {
    font-size: 40px;
    /* color: #ffffff; */
}

.success-title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 20px;
}

.success-info {
    text-align: center;
    margin-bottom: 30px;
}

.success-info p {
    font-size: 14px;
    color: #666666;
    margin-bottom: 8px;
}

.success-info p:last-child {
    margin-bottom: 0;
}

.success-actions {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.return-btn {

    width: 50%;
    height: 40px;
    background-color: #f5f5f5;
    border: none;
    color: #666666;
    border-radius: 4px;
    font-size: 14px;
}

.return-btn:hover {
    background-color: #e8e8e8;
    color: #666666;
}
</style>